export const version = 'v5.5.0';
